import * as jsxRuntime from "/builds/lya-protect/tutelaire/lya-protect-form-tutelaire/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment